module.exports = __webpack_public_path__ + "static/media/contact-bg.9cc6efd1.svg";